import { store } from 'src/store'
import { post } from 'src/axios/post'

export default async function awardNewbie (key, type) {
  // if either company or user array contains the key, don't post
  if (type === 'company') {
    if (store.getters['company/getCompanyNewbie'].includes(key)) {
      return
    }
  }
  else if (type === 'user') {
    if (store.getters.getNewbie.includes(key)) {
      return
    }
  }
  else {
    return
  }

  await post('v1/newbie/award', {
    newbie: key
  })
}
